import React, {useEffect, useState} from 'react';

import {Keys, Modules} from '../../config/AppConfig';
import {isModuleAllocated, printError, printLog} from "../../utils/AppUtils";
import {useTheme} from '../../../common/ProjectThemeProvider';
import {Label, LoadingSection} from "../../../common/fusion-ui"
import {checkNullArr, checkNullJson, checkNullStr, getJsonValue, isBoolTrue, isJsonValueTrue} from 'common/fusion-ui/utils/ReactUtils';
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {CSPanel, DocPanel, LinkPanel, PubPanel} from "../../index";
import {useConfig} from "../../context/ConfigProvider";

const RecentResPanel = React.memo(({
                                       panelData = {}, loadingStatus = {}, onRecordsUpdate,
                                   }) => {
    const TAG = 'RecentResPanel';

    const moduleName = Modules.RecentResources;

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {updateConfig} = useConfig();

    const module_cs = 'Case Studies';

    const SectionTypes = {
        doc: isModuleAllocated(Modules.Documents) && {id: 0, label: Modules.Documents},
        pub: isModuleAllocated(Modules.Publication) && {id: 1, label: Modules.Publication + 's'},
        cs: isModuleAllocated(Modules.CaseStudy) && {id: 2, label: module_cs},
        link: isModuleAllocated(Modules.UsefulLinks) && {id: 3, label: Modules.UsefulLinks},
    };
    // const DEF_TAB_ID = SectionTypes.doc.id;
    const DEF_TAB_ID = checkNullArr(Object.values(SectionTypes)) ? Object.values(SectionTypes)[0].id : '';

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        panelData: `panelData`,
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        // log('useEffect.panelData:', panelData, 'loadingStatus:', loadingStatus);
        updateField(Fields.isDataLoading, true);
        updateField(Fields.panelData, panelData);
        updateField(Fields.isDataLoading, !isJsonValueTrue(loadingStatus, 'loaded'));
        updateField(Fields.isDataFound, isJsonValueTrue(loadingStatus, 'success'));

        updateField(Fields.dataLoadingMsg, getJsonValue(loadingStatus, 'msg'));
    }, [panelData, loadingStatus]);

    useEffect(() => {
        if (!checkNullStr(getField(Fields.currSelectedTabId))) {
            updateConfig(Keys.tracker_currPageModule, moduleName);
            updateConfig(Keys.tracker_currPageTag, TAG);
            updateField(Fields.currSelectedTabId, DEF_TAB_ID);
        }
    }, []);

    return (<>
        {createPanel()}
    </>);

    function createPanel() {
        return <div className={' bg-infox'}>
            <LoadingSection
                labelClassName={'m-1 w-100 fs-xxl fw-semi-bold'}
                heightClass={75}
                color={theme.primary50}
                success={isFieldTrue(Fields.isDataFound)}
                loading={isFieldTrue(Fields.isDataLoading)}
                msg={getField(Fields.dataLoadingMsg)}
            />

            {/*record-list */}
            {(isFieldTrue(Fields.isDataFound) && isFieldTrue(Fields.isDataFound)) && <div className={"w-100 m-0 p-0 pt-1"}>
                {/*doc-panel*/}
                {checkNullArr(getModuleRecords(Modules.Documents)) && <div className={''}>
                    <Label className={'fw-bold m-0 p-0 mt-1 px-2 mb-n1'} textAt={'start'} color={theme.text50}>
                        Recent {Modules.Documents}
                    </Label>
                    <DocPanel
                        showHeader={false}
                        showPagination={false}
                        fromSearchPage={true}
                        showControls={false}
                        recordList={getModuleRecords(Modules.Documents)}
                        loadingStatus={{loaded: true, success: true, msg: ''}}
                    />
                </div>}

                {/*pub-panel*/}
                {checkNullArr(getModuleRecords(Modules.Publication)) && <div className={'mx-n2'}>
                    <Label className={'fw-bold m-0 p-0 mt-2 px-4'} textAt={'start'} color={theme.text50}>
                        Recent {Modules.Publication}s
                    </Label>
                    <PubPanel
                        showHeader={false}
                        showPagination={false}
                        showControls={false}
                        recordList={getModuleRecords(Modules.Publication)}
                        loadingStatus={{loaded: true, success: true, msg: ''}}
                    />
                </div>}

                {/*cs-panel*/}
                {checkNullArr(getModuleRecords(Modules.CaseStudy)) && <div className={'mx-n2'}>
                    <Label className={'fw-bold m-0 p-0 mt-2 px-4'} textAt={'start'} color={theme.text50}>
                        Recent {module_cs}
                    </Label>
                    <CSPanel
                        showHeader={false}
                        showPagination={false}
                        showControls={false}
                        recordList={getModuleRecords(Modules.CaseStudy)}
                        loadingStatus={{loaded: true, success: true, msg: ''}}
                    />
                </div>}

                {/*link-panel*/}
                {checkNullArr(getModuleRecords(Modules.UsefulLinks)) && <div className={'mx-n2'}>
                    <Label className={'fw-bold m-0 p-0 mt-2 px-4'} textAt={'start'} color={theme.text50}>
                        Recent {Modules.UsefulLinks}
                    </Label>
                    <LinkPanel
                        showHeader={false}
                        showPagination={false}
                        showControls={false}
                        recordList={getModuleRecords(Modules.UsefulLinks)}
                        loadingStatus={{loaded: true, success: true, msg: ''}}
                    />
                </div>}
            </div>}
        </div>
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getModuleRecords(moduleName) {
        if (checkNullJson(getField(Fields.panelData))) {
            return checkNullArr(getJsonValue(getField(Fields.panelData), moduleName)) ? getJsonValue(getField(Fields.panelData), moduleName) : [];
        }
        return [];
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default RecentResPanel;
